import { Injectable } from '@angular/core';
import {AbstractStompService} from './abstract/abstract-stomp-service';
import {AuthenticationService} from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class MapEditLockStompService extends AbstractStompService {

  constructor(protected authenticationService: AuthenticationService) {
    super(authenticationService);
  }

  public servicePath(): string {
    return '/map';
  }

  public receivingPrefix(): string {
    return '/lock';
  }

}
